import type { RouteObject } from 'react-router-dom';

import { myPageMaps } from '../myPageMaps';

const myInfoRoutes: RouteObject[] = [
  {
    path: myPageMaps.index.path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/MyPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps.info.path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/info/InformationPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps.coupon.path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/coupon/CouponPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps.settlement.path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/settlement/SettlementPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps['credit-card'].path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/credit-card/MyCreditCardPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps['plan'].path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/plan/MyPlanPage');
      return {
        Component: Page,
      };
    },
  },
  {
    path: myPageMaps['credit'].path,
    async lazy() {
      const { default: Page } = await import('@/app/my-page/credit/CreditPage');
      return {
        Component: Page,
      };
    },
  },
];

export default myInfoRoutes;
